/*
 *   File : group-detail.js
 *   Author : https://evoqins.com
 *   Description : Group detail page
 *   Integrations : 'react-toastify'
 *   Version : 1.0.0
*/

import React, { Fragment, useEffect, useRef, useState } from 'react';
import { CustomDataTable } from '../../Components/DataTable';
import { useLocation, useNavigate } from 'react-router-dom';
import { APIService } from '../../Service';
import { PrimaryButton } from '../../Components/Buttons';
import { CreateUserGroup, SuccessModal } from '../../Components/Modal';
import { Modal } from 'bootstrap';
import { EmptyScreen } from '../../Components/Others';
import { toast } from 'react-toastify';

const GroupDetail = () => {

    const { state } = useLocation();
    const scrollRef = useRef(null);
    const navigate = useNavigate();

    const [currentPage, setCurrentPage] = useState(1);
    const [userList, setUserList] = useState({});
    const [loader, setLoader] = useState(true);

    const [createGroupModal, setCreateGroupModal] = useState(false);

    const [createGroupSuccess, setCreateGroupSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const [confirmStatus, setConfirmStatus] = useState(false);


    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        if (state !== null) {
            _listUsers();
        } else {
            navigate("/customers", {
                state: {
                    tab_index: 1,
                    type: 'user_group',
                }
            });
        }
        console.log("state", state);

    }, [state]);

    useEffect(() => {
        if (createGroupModal === true) {
            const modal = new Modal(document.getElementById("create-group-modal"));
            modal.show();
        }
    }, [createGroupModal]);

    useEffect(() => {
        if (createGroupSuccess === true) {
            const modal = new Modal(document.getElementById("success-modal"));
            modal.show();
        }
    }, [createGroupSuccess]);

    const _handleBack = () => {
        navigate("/customers", {
            state: {
                tab_index: 2,
                type: 'user_group',
            }
        });
    };

    // handle table page change 
    const _handleTablePageChange = (page_num) => {
        _listUsers(page_num);
        setCurrentPage(page_num);
        if (scrollRef.current) {
            scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    };

    // handle add users more
    const _handleAddUsers = () => {
        setCreateGroupModal(true);
    };

    // handle continue create group to get group name 
    const _handleContinue = (name, users) => {

        _addUsers(users)

    };

    // user group column
    const USER_GROUP_COLUMN = [
        {
            name: 'User name',
            selector: row => row.username || "-",
            width: "260px",
            sortable: true,
        },
        {
            name: 'Email address',
            cell: (row) =>
                <a href={`mailto:${row.email}`} target='_blank' className='text-truncate e-text-smoky-black text-decoration-none text-decoration-hover-underline'>
                    {row.email}
                </a>,
            width: "340px",
            sortable: true,
        },
    ];

    // API - Get user list
    const _listUsers = (page_num = currentPage) => {
        let is_post = true;
        let url = 'user/list-users';
        let request = {
            "page_num": page_num,
            "page_size": 10,
            "user_group_id": state?.group_id
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setUserList(response.data);
            } else {
                setUserList({ data: [] });
            }
            setLoader(false);
        })
    };


    // API - Add users in group
    const _addUsers = (user) => {

        let updated_user_ids = [];
        updated_user_ids = user?.map(item => item.id);


        if (updated_user_ids.length === 0) {
            toast.dismiss();
            toast.error("Select at least one user", { type: "error" });
            return;
        }

        let is_post = true;
        // let url = 'send-email/add-users';
        let url = 'user/add-user-group';
        let request = {
            "group_id": state?.group_id,
            "type": 1,
            "customer_ids": updated_user_ids
        }

        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setConfirmStatus(true);
                setCreateGroupSuccess(true);

                setSuccessMessage(response.message);
            } else {
                toast.dismiss();
                toast.success(response.message, { type: "error" });
            }
        })
    };

    return (
        <Fragment>
            <section className='e-section-height pb-5' >

                <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-400 line-height-24px'>
                        <span className='text-decoration-hover-underline cursor-pointer'
                            onClick={() => _handleBack()}>
                            Customers</span> /
                        <span className='e-font-weight-600 ps-1'>
                            User groups
                        </span>
                    </p>
                </div>


                <div className='padding-52px-lr margin--80px-top'>
                    <div className='e-bg-ghost-white border-radius-16  '>
                        <div ref={scrollRef} className='padding-32px-lr padding-32px-top'>
                            <div className='d-flex align-items-center justify-content-between'>
                                <h4 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                    User list
                                </h4>
                                <PrimaryButton name="Add user"
                                    paddingBlock='padding-12px-tb padding-40px-lr'
                                    onClick={_handleAddUsers} />
                            </div>
                        </div>

                        {loader ?
                            <div className='d-flex align-items-center min-vh-50 justify-content-center'>
                                <img src={require("../../Assets/Image/loader.gif")}
                                    draggable={false}
                                    width={80}
                                    height={80}
                                    alt='loader'
                                    className='text-center' />
                            </div>
                            :
                            <div className='e-data-table-wrapper-default-updated pt-3 padding-32px-bottom'>
                                {userList.data.length !== 0 ?
                                    <CustomDataTable columns={USER_GROUP_COLUMN}
                                        data={userList.data}
                                        pagination={true}
                                        paginationPerPage={10}
                                        paginationDefaultPage={userList.current_page}
                                        paginationTotalRows={userList.total_count}
                                        lastPage={userList.total_page}
                                        onChangePage={_handleTablePageChange}
                                    />
                                    :
                                    <EmptyScreen
                                        image={require('../../Assets/Image/NotFound/no-data.png')}
                                        title='No data found'
                                        description={``}
                                    />
                                }
                            </div>
                        }
                    </div>
                </div>
            </section>

            {createGroupModal === true &&
                <CreateUserGroup type={2}
                    group_id={state?.group_id}
                    selectedUsers={userList.data}
                    confirmStatus={confirmStatus}
                    handleClose={() => {
                        setTimeout(() => {
                            setCreateGroupModal(false);
                        }, 200);
                    }}
                    handleContinue={_handleContinue}
                    handleSuccess={(message) => {
                        setTimeout(() => {
                            setCreateGroupModal(false);
                            setCreateGroupSuccess(true);
                        }, 200);
                        setSuccessMessage(message);
                    }}
                />
            }

            {createGroupSuccess === true &&
                <SuccessModal title="Success!"
                    description={successMessage ? successMessage : "Group created successfully. Customers have been added to the group."}
                    handleSuccess={() => {
                        setTimeout(() => {
                            setCreateGroupSuccess(false);
                            setConfirmStatus(false);
                        }, 200);

                        setLoader(true);

                        _listUsers();
                    }} />
            }
        </Fragment>
    )
}

export default GroupDetail;
